<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>数据中心</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>安全预警</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>安全预警列表</span>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="warnid" label="ID" width="50"></el-table-column>
          <el-table-column prop="title" label="设备名称" width="160"></el-table-column>
          <el-table-column prop="devid" label="设备ID"></el-table-column>
          <el-table-column label="预警信息" width="240">
            <template slot-scope="scope">
              <el-link :underline="false" type="warning" v-if="scope.row.level == 3">{{scope.row.msg}}</el-link>
              <el-link :underline="false" type="danger" v-else-if="scope.row.level == 2">{{scope.row.msg}}</el-link>
              <el-link :underline="false" type="primary" v-else>{{scope.row.msg}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="预警级别：" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.level == 3">Ⅲ</div>
              <div type="danger" v-else-if="scope.row.level == 2">Ⅱ</div>
              <div v-else>Ⅰ</div>
            </template>
          </el-table-column>
          <el-table-column prop="stime" label="首次预警时间" width="200"></el-table-column>
          <el-table-column prop="etime" label="当前预警时间" width="200"></el-table-column>
          <el-table-column prop="nums" width="120" label="预警次数"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.warnid)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.warnid)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    edit(ids) {
      this.$router.push({
        path: "/friend/add_news",
        query: {
          id: ids,
        },
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/dev_warning/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.type = 0;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/dev_warning/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>